import Autocomplete from 'vue-simple-suggest'
import ContactList from '../../js-api/ContactList'
import Zenkaku from '../../../zzl-lib/Zenkaku'

export default {
	name: 'ContactEditor',
	props: {
		value: {
			type: Object,
		}
	},
	data() {
		const registered = this.value.id !== ''
		return {
			registered,
			id: this.value.id || null,
			name: this.value.name || '',
			acName: this.value.name || '', // onSelect() 時には name に値が反映されないので補完時専用のデータを用意する
			kana: this.value.kana || '',
			staff_name: this.value.staff_name || '',
			tel: this.value.tel || '',
			email: this.value.email || '',
			autocompleted: registered,
			afterAutocompleted: this.value.name != null, // mounted 時に input イベントが発火するため
			autoCompleteStyle: {
				vueSimpleSuggest: 'bs-suggest-wrap',
				inputWrapper: 'bs-suggest-input-wrap',
				defaultInput: 'bs-suggest-input form-control',
				suggestions: 'bs-suggest-list',
				suggestItem: 'bs-suggest-item'
			}
		}
	},
	components: {
		Autocomplete
	},
	template: `
		<div class="contact-editor-container bs-suggest-formgroup" :class="{ autocompleted }">
			<div class="form-group">
				<label class="control-label">名称</label>
				<div class="form-controls">
					<Autocomplete
						v-model="name"
						:list="suggestionList"
						:styles="autoCompleteStyle"
						:filter-by-query="true"
						:filter="filterSuggestion"
						value-attribute="id"
						display-attribute="name"
						@input="onInput"
						@select="onSelect"
					>
						<div slot="suggestion-item" slot-scope="{ suggestion, query }">
							<div>{{ suggestion.name }}</div>
							<div v-if="suggestion.staff_name" class="small text-muted">担当：{{ suggestion.staff_name }}</div>
						</div>
					</Autocomplete>
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">よみがな</label>
				<div class="form-controls">
					<input type="text" class="form-control" v-model="kana" @change="onInput">
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">担当者名</label>
				<div class="form-controls">
					<input type="text" class="form-control" v-model="staff_name" @change="onInput">
					<p class="help-block">企業や団体で必要であれば入力してください</p>
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">電話</label>
				<div class="form-controls">
					<div class="form-subgroup">
						<input type="text" class="form-control" v-model="tel" @change="onInput">
					</div>
				</div>
			</div>
			<div class="form-group">
				<label class="control-label">メール</label>
				<div class="form-controls">
					<div class="form-subgroup">
						<input type="text" class="form-control" v-model="email" @change="onInput">
					</div>
				</div>
			</div>
		</div>
	`,
	mounted() {
	},
	methods: {
		suggestionList () {
			return ContactList.get()
		},
		filterSuggestion (contact, query) {
			const q = query.trim().toLowerCase()
			if (q === '') return true
			return contact.name.toLowerCase().indexOf(q) >= 0 || contact.kana.indexOf(Zenkaku.hiragana(q)) >= 0
		},
		onInput () {
			// Select イベントの発生後、一度 input イベントが発生するので、その input イベントは無視する
			if (this.afterAutocompleted) {
				this.afterAutocompleted = false
				return
			}

			this.autocompleted = false

			this.id = null
			this.notifyChange()
		},
		onSelect (contact) {
			this.autocompleted = true
			this.afterAutocompleted = true

			// 内容を設定
			this.id = contact.id
			this.acName = contact.name
			this.kana = contact.kana
			this.staff_name = contact.staff_name
			this.tel = contact.tel
			this.email = contact.email
			this.notifyChange()
		},
		notifyChange () {
			this.$emit('input', {
				id: this.id,
				name: this.autocompleted ? this.acName : this.name,
				kana: this.kana,
				staff_name: this.staff_name,
				tel: this.tel,
				email: this.email
			})
		}
	}
}
